import { Bar } from 'vue-chartjs'
import Api from '../../services/Api'
export default {
  extends: Bar,
  props: ['title', 'endpoint', 'filters', 'config'],
  data () {
    return {
			dataset: {},
			isRendered: false
    }
  },
  computed: {
		chartData() {
			return this.dataset
		},
		options: function () {
			return {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: false
				},
				responsive: true,
				maintainAspectRatio: false,
				tooltips: this.config.tooltip ? {
					enabled: false,
					custom: (tooltip) => {
						let tooltipEl = document.getElementById('chartjs-tooltip')
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.id = 'chartjs-tooltip';
							document.body.appendChild(tooltipEl);
						}
						if (tooltip.opacity === 0) {
							tooltipEl.style.opacity = 1
							return
						}
						tooltipEl.classList.remove('above', 'below', 'no-transform')
						if (tooltip.yAlign) {
							tooltipEl.classList.add(tooltip.yAlign)
						} else {
							tooltipEl.classList.add('no-transform')
						}

						function getBody(bodyItem) {
							return bodyItem.lines;
						}

						if (tooltip.body) {
							let titleLines = tooltip.title || [];
							let bodyLines = tooltip.body.map(getBody);
							let splitBody = bodyLines[0][0].split(': ')
							let item = {dataLabel: splitBody[0], value: splitBody[1], label: tooltip.title[0]}
							let currentDataset = this.dataset.datasets.find(d => {return d.label === item.dataLabel})
							let itemIndex = currentDataset.data.indexOf(parseInt(item.value) ? parseInt(item.value) : item.value)
							let datasetIndex = this.dataset.datasets.indexOf(currentDataset)
							if (this.dataset.tooltips) {
								let tooltipData = this.dataset.tooltips[datasetIndex][itemIndex]
								item = {...item, ...tooltipData}
							}
							let innerHtml = this.config.tooltip
							//TODO handle custom vars from tooltipData, ask Jan
							this.config.tooltipVars.forEach(v => {
								innerHtml = innerHtml.split(`{${v}}`).join(item[v])
							})
							tooltipEl.innerHTML = innerHtml
						}

						let position = this.$data._chart.canvas.getBoundingClientRect()
						tooltipEl.style.opacity = 1
						tooltipEl.style.position = 'absolute'
						tooltipEl.style.left = position.left + window.pageXOffset - 50 + tooltip.caretX + 'px'
						tooltipEl.style.top = position.top + 5 + window.pageYOffset + tooltip.caretY + 'px'
						tooltipEl.style.fontFamily = tooltip._bodyFontFamily
						tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px'
						tooltipEl.style.fontStyle = tooltip._bodyFontStyle
						tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px'
					}
				} : {
					displayColors: true
				},
				onClick: this.handle
			}
		}
	},
  methods: {
		getTooltipProper (item, body) {
			this.config.tooltipVars.forEach(v => {
				body = body.replace(`{${v}}`, item[v])
			})
			return body
		},
		handle (point, event) {
			const item = event[0]
			this.$emit('on-receive', {
				index: item._index,
				backgroundColor: item._view.backgroundColor,
				value: this.dataset.datasets[0].data[item._index],
				label: this.dataset.labels[item._index]
			})
		},
		formatDatasets (arr) {
			let newDatasets = []
			let colors = []
			arr.forEach(d => {
				d.data.forEach(ds => {
					colors.push(`rgb(${Math.round(Math.random() * 255)}, ${Math.round(Math.random() * 255)}, ${Math.round(Math.random() * 255)})`)
				})
				d.borderColor = colors
				d.backgroundColor = colors
				newDatasets.push(d)
			})
			return newDatasets
		},
		getCompanies () {
			let ret = []
			this.filters.companies.forEach(c => {
				ret.push(c.id)
			})
			return ret.join(',')
		},
		getSalesChannels () {
			let ret = []
			this.filters.salesChannels.forEach(c => {
				ret.push(c.value)
			})
			return ret.join(',')
		},
		getData () {
			this.$parent.loading = true
			this.$parent.empty = true
			if (this.isRendered) {
				this.$data._chart.destroy()
			}
			Api().get(`${this.endpoint}?
			start=${this.filters.date.split('#')[0]}
			&end=${this.filters.date.split('#')[1]}
			&companyIdArr=${this.getCompanies()}
			&salesChannels=${this.getSalesChannels()}
			&categories=${this.filters.subcat || this.filters.category}
			&orderDirection=${this.filters.sort}
			&orderField=${this.filters.orderField}
			&brands=${this.filters.brands.join(',')}
			&productIDs=${this.filters.products.join(',')}`)
				.then(res => {
					res.data.datasets = this.formatBarDatasets(res.data.datasets)
					this.dataset = res.data
					this.$emit(this.dataset.datasets.length === 0 ? 'noData' : 'yesData')
					this.$emit('finished')
					this.isRendered = true
				}).catch(error => {
					this.$notify({
					  group: 'foo',
					  type: 'error',
					  title: 'Error',
					  text: `Es gab ein Fehler mit Chart ${this.title}`
					});
			})
		}
	},
  mounted () {
		if (this.filters.companies.length > 0 && this.filters.salesChannels.length > 0) {
			this.getData()
		}
  },
  watch: {
		filters () {
			this.getData()
		},
		dataset () {
			this.renderChart(this.dataset, this.options)
		},
  }
}
